export default "<p>\n  Giovanni Emanuel (1847 - 1902) attore e impresario teatrale, scoprì il talento\n  della Duse\n</p>\n";